import * as jQuery from "jquery";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { Decrement } from "source/app/presentation/MainPanel/Calendar/CalendarEvents/Render/Editor/AdjustTime/Decrement";
import { Increment } from "source/app/presentation/MainPanel/Calendar/CalendarEvents/Render/Editor/AdjustTime/Increment";
import { ShowDateTimeLocalInput } from "source/app/presentation/MainPanel/Calendar/CalendarEvents/Render/Editor/Helpers/ShowDateTimeLocalInput";
import { ECalendarName } from "../../../../../../../../../motw_core/Calendar/ECalendarName";
import { ICalendarEvent } from "../../../../../../../../../motw_core/Calendar/ICalendarEvent";
import { ShareState } from "../../../../../../services/UI/State/ShareState";
import { DeleteEventLink } from "../../../CalendarEventDoneSwitch/DeleteEventLink/DeleteEventLink";
import { SelectCalendarForEvent } from "./SelectCalendarForEvent";
import { ShowGoalNameSuggestions } from "./ShowGoalNameSuggestions";
import { ICalendarEventEditorState } from "./ICalendarEventEditorState";
import { GetMatchingGoals } from "source/app/presentation/MainPanel/Calendar/CalendarEvents/Render/Editor/GetMatchingGoals";
import { calendarEvent_freeTime } from "motw_core/Constants/constants";
import { ShowEventType } from "./ShowEventType";
import { EditEventName } from "./EditEventName";
import { FirstEventDate } from "./FirstEventDate";

export function CalendarEventEditor({
    eventData,
    OnOKAction,
}: {
    eventData: ICalendarEvent;
    OnOKAction: (withEventData?: ICalendarEvent) => Promise<void>;
}) {
    const [state, setState] = React.useState<ICalendarEventEditorState>({
        calendarEvent: eventData,
        matchingGoals: [],
    });

    ShareState(ESharedFunction.CalendarEventEditor_state, state, setState);

    React.useEffect(() => {
        const onLoadName =
            state.calendarEvent.name === calendarEvent_freeTime
                ? ``
                : state.calendarEvent.name;

        // Don't allow calendar name to be "Free"
        if (
            state.calendarEvent.calendar === ECalendarName[ECalendarName.Free]
        ) {
            setState({
                ...state,
                calendarEvent: {
                    ...state.calendarEvent,
                    name: onLoadName,
                    calendar: ECalendarName[ECalendarName.Timeblock],
                },
            });

            jQuery(`#clickTarget_calendarEvent_name`).focus();
        }
    }, []);

    React.useEffect(() => {
        if (state.calendarEvent.name === calendarEvent_freeTime) {
            return;
        }

        const matchingGoals = GetMatchingGoals(state.calendarEvent.name);

        setState({ ...state, matchingGoals });
    }, [state.calendarEvent.name]);

    return (
        <div>
            <ShowEventType {...{ state }} />
            <FirstEventDate {...{ state, setState }} />
            <DeleteEventLink
                {...{
                    eventData,
                }}
            />
            <div>
                <EditEventName {...{ state, setState, OnOKAction }} />
                <ShowGoalNameSuggestions
                    {...{
                        state,
                        SaveAction: OnOKAction,
                    }}
                />
                <ShowDateTimeLocalInput
                    {...{
                        state,
                        setState,
                        label: `start`,
                        isReadOnly: state.calendarEvent.isRepeating,
                    }}
                />
                <Increment {...{ state, setState }} />
                <ShowDateTimeLocalInput
                    {...{
                        state,
                        setState,
                        label: `end`,
                        isReadOnly: state.calendarEvent.isRepeating,
                    }}
                />
                <Decrement {...{ state, setState }} />
                <SelectCalendarForEvent {...{ state, setState }} />
            </div>
        </div>
    );
}
